export default {
  navigationBarTitleText: '联系人',
};
